import '../components/css/Dashboard.css';
import Banner from '../components/Banner';
import Header from '../components/Header';

function Dashboard() {

  const features = [
    "Prednostné zobrazovanie",
    "Vrchné priečky na Google",
    "Reklama na stránke",
    "Vyplnenie profilu",
    "Aktualizácia informácií",
    "Propagácia na sociálnych sieťach",
    "Zobrazovanie na službomat"
  ];

  // Stripe Payment Links
  const monthlyLink = "https://buy.stripe.com/test_8x2cMXfMj3FBbPD7KY5sA00"; // replace with your Stripe monthly link
  const yearlyLink = "https://buy.stripe.com/test_dRm00b6bJekfaLz6GU5sA01";   // replace with your Stripe yearly link

  return (
    <>
      <Header />
      <Banner />
      <div className="dashboard">
        <div className="subscription-cards">
          {/* Free Plan */}
          <div className={`subscription-card free`}>
            <h2>Bezplatný<br />program</h2>
            <br />
            <ul className="feature-list" style={{ marginTop: "40px" }}>
              {features.map((feature, index) => (
                <li key={index} className={index > 5 ? "feature-check" : "feature-cross"}>
                  {index > 5 ? <i class="material-icons">check</i> : <i class="material-icons" id='close'>close</i>} {feature}
                </li>
              ))}
            </ul>
          </div>

          {/* Silver Plan */}
          <div className={`subscription-card silver`}>
            <h2>Mesačné<br />predplatné</h2>
            <p>25€ / Mesačne</p>
            <p style={{ fontSize: "12px", marginTop: "0px", color: "lightgray" }}>(300€ / Ročne)</p>
            <ul className="feature-list">
              {features.map((feature, index) => (
                <li key={index} className="feature-check"><i class="material-icons">check</i> {feature}</li>
              ))}
            </ul>
            {/* Stripe Button */}
            <a href={monthlyLink} target="_blank" rel="noopener noreferrer">
              <button className="subscribe-button" id='silver'>Kúpiť Mesačné</button>
            </a>
          </div>

          {/* Gold Plan */}
          <div className='subscription-card gold'>
            <h2>Ročné <br />predplatné</h2>
            <p>16€ / Mesačne</p>
            <p style={{ fontSize: "12px", marginTop: "0px", color: "lightgray" }}>(200€ / Ročne)</p>
            <ul className="feature-list">
              {features.map((feature, index) => (
                <li key={index} className="feature-check"> <i class="material-icons">check</i> {feature}</li>
              ))}
            </ul>
            {/* Stripe Button */}
            <a href={yearlyLink} target="_blank" rel="noopener noreferrer">
              <button className="subscribe-button" id='gold'>Kúpiť Ročné</button>
            </a>
          </div>

        </div>
      </div>
    </>
  );
}

export default Dashboard;
